import React, { FC, useContext, useEffect, useState } from "react";
import { Button, Col, Row } from "antd";
import styles from "./info-cards.module.scss";
import Title from "antd/lib/typography/Title";
import Image from "next/image";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import { useRouter } from "next/router";
import { ScreenSizeContext } from "../../../pages/_app";

interface Enumeration {
  index: number;
  last?: boolean;
}

export interface InfoSectionCardProps {
  route?: string;
  title: string;
  imageSrc: string;
  subTitle?: string;
  content: React.ReactNode;
  tag?: string;
}

export const InfoSectionCard: FC<InfoSectionCardProps & Enumeration> = ({
  title,
  subTitle,
  content,
  tag,
  imageSrc,
  route,
  index,
  last,
}) => {
  const router = useRouter();

  const [mobile, setMobile] = useState<boolean>(false);

  const { isMobile } = useContext(ScreenSizeContext);

  useEffect(() => {
    setMobile(isMobile);
  }, [isMobile]);

  return (
    <div className={styles.infoCard} id={`info-${index}`}>
      <Row style={{ height: "100%" }} gutter={32} align={"top"}>
        <Col
          xs={{ span: 0 }}
          lg={{ span: 9 }}
          style={{
            borderRadius: 5,
          }}
        >
          <div style={{ height: 350 }}>
            <Image
              src={imageSrc}
              objectFit={"cover"}
              layout={"fill"}
              style={{ borderRadius: 5 }}
            />
          </div>
        </Col>
        <Col xs={{ span: 24 }} lg={{ span: 14, offset: 1 }}>
          <div className={styles.tagWrapper}>
            {tag && <span className={styles.tag}>{tag}</span>}
            {route && (
              <span
                className={styles.button}
                onClick={() => router.push(route)}
              >
                <RightOutlined />
              </span>
            )}
          </div>

          <div style={{ marginBottom: 22 }}>
            <span
              style={{
                color: "white",
                fontWeight: 400,
                fontSize: "2em",
              }}
            >
              {title}
            </span>
          </div>
          {subTitle && (
            <Title level={3} style={{ color: "white", fontWeight: 100 }}>
              {subTitle}
            </Title>
          )}
          <hr
            style={{
              borderTop: "1px solid #bbb",
              borderBottom: "none",
            }}
          />
          {content}
        </Col>
      </Row>
      {!mobile && !last && (
        <div style={{ bottom: -200 }}>
          <Button
            shape={"circle"}
            size={"large"}
            className={styles.downButton}
            style={{
              color: "black",
              backgroundColor: "white",
              float: "right",
              width: 50,
              height: 50,
              paddingTop: 10,
              fontSize: "1.4em",
            }}
            onClick={() => router.push(`/home#info-${index + 1}`)}
          >
            <DownOutlined />
          </Button>
        </div>
      )}
    </div>
  );
};
